import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Product_Interface, Product_Interface } from 'src/app/Interface/Product_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProductService } from 'src/app/Service/Product/Product.service';
import { ProductGroupService } from 'src/app/Service/ProductGroup/ProductGroup.service';

@Component({
  selector: 'app-ProductEdit',
  templateUrl: './ProductEdit.component.html',
  styleUrls: ['./ProductEdit.component.css']
})
export class ProductEditComponent implements OnInit {

  Token: String = ""
  EditRecord: Number

  constructor(
    private Product_Service: ProductService,
    private ProductGroup_Service: ProductGroupService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private route: ActivatedRoute,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.EditProduct = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token, 2207).subscribe(
      data => {
        this.Product_Service.GetSingle(this.Token, this.EditRecord).subscribe(
          data => {

            this.Data_Seleted_Record.id=data.product_group_id
            this.Data_Seleted_Record.title=data.group_title

            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.ReadData_ProductGroup()
          }
        )
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }


  //#region  Group

  modalRef_ProductGroup: any;
  page: number = 0

  ProcssingProductGroup: boolean = false

  Search_Name_ProductGroup_Table: string = ''

  openModal_ProductGroup(template: TemplateRef<any>) {
    this.modalRef_ProductGroup = this.modalService.show(template);
  }

  DataList_ProductGroup: Array<General_Interface> = []
  Data_Seleted_Record: General_Interface = Empty_General_Interface()



  ReadData_ProductGroup() {
    this.ProcssingProductGroup = true
    this.ProductGroup_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_ProductGroup = data
        this.ProcssingProductGroup = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Set_Selected_ProductGroup_Record(item) {
    this.Data_Seleted_Record = item
    this.modalRef_ProductGroup.hide()
  }

  //#endregion



  //#region  Form Add

  EditProduct: FormGroup;

  get_Form_Id() {
    return this.EditProduct.get('id') as FormControl;
  }

  get_Form_Title() {
    return this.EditProduct.get('Title') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitEditProduct() {
    if (this.Data_Seleted_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("Select the product group.")
    }
    else {
      var Record: Product_Interface = Empty_Product_Interface()
      Record.id = this.get_Form_Id().value
      Record.product_group_id = this.Data_Seleted_Record.id
      Record.group_title = this.Data_Seleted_Record.title + ''
      Record.title = this.get_Form_Title().value
      this.InProccessing = true
      this.Product_Service.EditProduct(Record, this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else {

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }
  }

}
